export default __webpack_public_path__ + "3773fd160c1f944e70ddf2978262a631.png";